<template>
    <tr v-if="negotiation">
        <td :id="'negotiation-' + negotiation.id">
            <div
                v-if="negotiation.state === 'pending'"
                class="c-tab-state"
                :class="negotiation.state"
            >
                <span v-if="!negotiation.canOperate" class="sended">
                    Negociación enviada
                </span>
                <span v-else> Negociación recibida </span>
            </div>
            <div v-else class="c-tab-state" :class="negotiation.state">
                <span>
                    {{ $t(`offer.state.${negotiation.state}`) }}
                </span>
            </div>
        </td>
        <td :data-label="participantsRol">
            <div class="organization-name">
                {{
                    negotiation.offeror.organization.businessName
                        ? `${negotiation.offeror.organization.businessName},`
                        : ""
                }}
            </div>
            {{ negotiation.offeror.name }}
            <span class="date small">
                {{ localeDate(negotiation.createdAt) }}
            </span>
        </td>

        <td
            class="negotiable-attributes"
            data-label="Atributos negociados"
            v-if="!this.zeroNegTotalDiference()"
        >
            <div v-if="offer.negotiableAttributes.deliveryAtDestination">
                <span>Entrega en destino:</span>
                <strong>{{
                    negotiation.deliveryAtDestination ? "Si" : "No"
                }}</strong>
            </div>
            <div v-if="offer.negotiableAttributes.price">
                <span>Precio s/IVA:</span>
                <strong>
                    {{ localePrice(negotiation.price) }}
                    <small class="variance"
                        >({{ negoDiff(negotiation.price, offer.price) }})</small
                    >
                </strong>
            </div>
            <div
                data-test="quantity"
                v-if="offer.negotiableAttributes.quantity"
            >
                <span>Cantidad:</span>
                <strong>
                    {{ negotiation.quantity }}
                    <small class="variance"
                        >({{
                            negoDiff(negotiation.quantity, offer.quantity)
                        }})</small
                    >
                </strong>
            </div>
            <div v-if="offer.negotiableAttributes.slaughterWeight">
                <span>Peso faena:</span>
                <strong>
                    {{ negotiation.quality.slaughterWeight }} (± 5) Kgs
                    <small class="variance"
                        >({{
                            negoDiff(
                                negotiation.quality.slaughterWeight,
                                offer.quality.slaughterWeight
                            )
                        }})</small
                    >
                </strong>
            </div>
            <div v-if="offer.negotiableAttributes.leanQuality">
                <span>Calidad magro:</span>
                <strong>
                    {{ negotiation.quality.leanQuality }}
                    <small class="variance">{{
                        negoLeanQuality(
                            negotiation.quality.leanQuality,
                            offer.quality.leanQuality
                        )
                    }}</small>
                </strong>
            </div>
            <div v-if="offer.negotiableAttributes.performance">
                <span>Rendimiento:</span>
                <strong>
                    {{ negotiation.quality.performance }} %
                    <small class="variance"
                        >({{
                            negoDiff(
                                negotiation.quality.performance,
                                offer.quality.performance
                            )
                        }})</small
                    >
                </strong>
            </div>
            <div v-if="offer.negotiableAttributes.dorsalFat">
                <span>Grasa dorsal:</span>
                <strong>
                    {{ negotiation.quality.dorsalFat }} mm
                    <small class="variance"
                        >({{
                            negoDiff(
                                negotiation.quality.dorsalFat,
                                offer.quality.dorsalFat
                            )
                        }})</small
                    >
                </strong>
            </div>
            <div v-if="offer.negotiableAttributes.securePayment.lock">
                <span>Pago seguro:</span>
                <strong>
                    {{ negotiation.securePayment ? "Si" : "No" }}
                </strong>
            </div>
            <div v-if="offer.negotiableAttributes.securePayment.percentage">
                <span>Porcentaje de pago:</span>
                <strong>
                    {{
                        negotiation.securePayment
                            ? negotiation.securePayment.percentage + " %"
                            : "-"
                    }}
                    <small
                        class="variance"
                        v-if="negotiation.securePayment && offer.securePayment"
                        >({{
                            negoDiff(
                                negotiation.securePayment.percentage,
                                offer.securePayment.percentage
                            )
                        }})</small
                    >
                </strong>
            </div>
            <div v-if="offer.negotiableAttributes.securePayment.lapse">
                <span>Fecha de transferencia:</span>
                <strong>
                    {{
                        negotiation.securePayment
                            ? negotiation.securePayment.lapse + " hs."
                            : "-"
                    }}
                    <small
                        class="variance"
                        v-if="negotiation.securePayment && offer.securePayment"
                        >({{
                            negoDiff(
                                negotiation.securePayment.lapse,
                                offer.securePayment.lapse
                            )
                        }})</small
                    >
                </strong>
            </div>
            <div v-if="negotiationMsg">{{ negotiationMsg }}</div>
        </td>
        <td v-else>
            <div class="direct-offer-negotiation centerx">
                <div class="secure-payment">
                    <div class="negotiable">
                        <div class="wrapper">
                            <vs-icon icon="info"></vs-icon>
                            Oferta de cierre directo
                        </div>
                    </div>
                </div>
            </div>
        </td>

        <td class="actions">
            <template
                v-if="
                    negotiation.state === 'pending' &&
                    this.filterType !== 'finishedNegotiations'
                "
            >
                <template v-if="negotiation.canOperate">
                    <div
                        vs-trigger-click
                        v-show="activeState && !action"
                        class="buttons"
                    >
                        <button
                            data-test="button-acceptDirectNegotiation"
                            @click="setNegotiation('accept!')"
                            title="Confirmar"
                            class="btn btn-secondary btn--inverted btn--icon success"
                        >
                            <vs-icon icon="check"></vs-icon>
                        </button>
                        <button
                            data-test="button-deneidDirectNegotiation"
                            @click="setNegotiation('reject!')"
                            title="Rechazar"
                            class="btn btn-secondary btn--inverted btn--icon danger"
                        >
                            <vs-icon icon="close"></vs-icon>
                        </button>
                        <button
                            data-test="button-negotiationDirect"
                            ref="negotiateBtn"
                            @click="setNegotiation('negotiate!')"
                            title="Negociar"
                            class="btn btn-secondary btn--inverted btn--icon negotiate"
                        >
                            <vs-icon icon="compare_arrows"></vs-icon>
                        </button>
                    </div>
                </template>
                <div
                    v-if="
                        !negotiation.canOperate &&
                        !action &&
                        activeState &&
                        hideButtonToAdmin()
                    "
                    class="buttons"
                >
                    <button
                        @click="setNegotiation('cancel!')"
                        title="Cancelar"
                        class="btn btn--inverted btn--with-icon danger"
                    >
                        <vs-icon icon="delete"></vs-icon> Cancelar
                    </button>
                </div>
                <div
                    v-if="action && action !== 'negotiate!'"
                    class="confirmation"
                >
                    <button class="btn btn-secondary" @click="cleanNegotiation">
                        Cancelar
                    </button>
                    <button
                        data-test="confirmNegotiation"
                        class="btn btn--inverted success"
                        @click="takeActionOnNegotiation()"
                    >
                        Confirmar
                    </button>
                </div>
            </template>
        </td>
    </tr>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
    name: "negotiation-row",
    props: {
        negotiation: {
            type: Object,
            required: true,
        },
        offer: {
            type: Object,
            required: true,
        },
        filterType: {
            type: String,
            required: false,
            default: "activeOffers",
        },
    },
    data() {
        return {
            negotiationMsg: "",
            action: "",
        };
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.User.currentUser,
        }),
        activeState() {
            return [
                "published",
                "pending",
                "in_negotiation",
                "accept_pending",
            ].includes(this.offer.state); // Include 'expired', see isuue #442
        },
        participantsRol() {
            var title = "Vendedor";
            if (this.offer.offerType.split("_")[1] === "sell") {
                title = "Comprador";
            }
            return title;
        },
    },
    methods: {
        zeroNegTotalDiference() {
            // La idea de este método es diferenciar si una oferta fue "Negociada" sin modificar
            // ... ningún atributo negociable

            let priceDif = this.negoDiff(
                this.negotiation.price,
                this.offer.price
            );
            if (priceDif != 0) return false;

            let quantityDif = this.negoDiff(
                this.negotiation.quantity,
                this.offer.quantity
            );
            if (quantityDif != 0) return false;

            let weightDif = this.negoDiff(
                this.negotiation.quality.slaughterWeight,
                this.offer.quality.slaughterWeight
            );
            if (weightDif != 0) return false;

            
            if (
                this.negotiation.quality.leanQuality !==
                this.offer.quality.leanQuality
            ) {
                return false;
            }

            let performanceDif = this.negoDiff(
                this.negotiation.quality.performance,
                this.offer.quality.performance
            );
            if (performanceDif != 0) return false;

            let fatDif = this.negoDiff(
                this.negotiation.quality.dorsalFat,
                this.offer.quality.dorsalFat
            );
            if (fatDif != 0) return false;

            // De acá para abajo es todo lo relacionado al pago seguro.
            let sameSecurePayment = false;
            if (
                this.offer.negotiableAttributes.securePayment &&
                this.offer.negotiableAttributes.securePayment.lock
            ) {
                let spDiff = 1;

                if (this.offer.negotiableAttributes.securePayment.percentage) {
                    if (
                        this.negotiation.securePayment &&
                        this.offer.securePayment
                    ) {
                        spDiff = this.negoDiff(
                            this.negotiation.securePayment.percentage,
                            this.offer.securePayment.percentage
                        );
                    } else {
                        spDiff = 0;
                        if (
                            (this.offer.securePayment == null &&
                                this.negotiation.securePayment != null) ||
                            (this.offer.securePayment != null &&
                                this.negotiation.securePayment == null)
                        ) {
                            spDiff = 1;
                        }
                    }
                } else {
                    spDiff = 0;
                    console.log("camino 3");
                }

                let transferDif = 1;
                if (this.offer.negotiableAttributes.securePayment.lapse) {
                    if (
                        this.negotiation.securePayment &&
                        this.offer.securePayment
                    ) {
                        transferDif = this.negoDiff(
                            this.negotiation.securePayment.lapse,
                            this.offer.securePayment.lapse
                        );
                    } else {
                        transferDif = 0;
                    }
                } else {
                    transferDif = 0;
                }

                if (transferDif === 0 && spDiff === 0) {
                    sameSecurePayment = true;
                } else {
                    sameSecurePayment = false;
                }
            } else {
                sameSecurePayment = true;
            }
            if (sameSecurePayment == false) return false;

            // Chequeo si la entrega destino u origen es la misma.
            if (this.offer.negotiableAttributes.deliveryAtDestination) {
                if (
                    this.negotiation.deliveryAtDestination !==
                    this.offer.deliveryAtDestination
                )
                    return false;
            }

            return true;
        },
        hideButtonToAdmin() {
            if (this.currentUser.admin) {
                return false;
            }
            return true;
        },
        localeDate(str) {
            return new Date(Date.parse(str) + 3.6e6 * 3).toLocaleDateString();
            // return (new Date(str)).toLocaleDateString()
        },
        localePrice(price) {
            return (
                "$/kg " +
                price.toLocaleString("es", { minimumFractionDigits: 2 })
            );
        },
        negoDiff(attr, value) {
            let diff = attr - value;
            if (diff === +diff && diff !== (diff | 0)) {
                diff = diff.toFixed(2);
            }
            if (diff > 0) {
                return "+ " + diff;
            } else {
                return diff;
            }
        },
        negoLeanQuality(diff, value) {
            if (diff === value) {
                return "";
            } else {
                return ` (${value})`;
            }
        },
        setNegotiation(action) {
            this.action = action;
            this.$emit("negotiation-action", this.action);
            if (this.action === "negotiate!") {
                this.$emit("in-negotiation", this.negotiation);
            }
        },
        cleanNegotiation() {
            this.action = "";
            this.$emit("negotiation-action", this.action);
        },
        takeActionOnNegotiation() {
            this.$emit("take-action", this.negotiation);
        },
    },
};
</script>
